export default __webpack_public_path__ + "static/media/NL.cf1b207e.svg";